import { isAfter } from 'date-fns';

import type { Me } from '@/entities/me';
import type { FeatureFlagChecker } from '@/hooks/use-feature-flag';

import type { News } from '../../types';

import { getFeatureFlaggedNews } from './get-feature-flagged-news';
import { getFilteredCustomersNews } from './get-filtered-customers-news';
import { getGeneralNews } from './get-general-news';

export function getManualNews(
  now: Date,
  featureFlag: FeatureFlagChecker,
  me: Me,
): News[] {
  const generalNews = getGeneralNews();
  const featureFlaggedNews = getFeatureFlaggedNews(
    featureFlag,
    me.config.type,
    me.config.id === '49',
  );
  const filteredCustomersNews = getFilteredCustomersNews(
    featureFlag,
    me.config.id,
  );

  const aggregatedManualNews: News[] = [
    ...generalNews,
    ...featureFlaggedNews,
    ...filteredCustomersNews,
  ];

  const customerId = me.config.id;

  return aggregatedManualNews.filter(function (
    news: News | undefined,
  ): news is News {
    if (!news) {
      return false;
    }

    if (news.expiredAt && isAfter(now, news.expiredAt)) {
      return false;
    }

    if (news.excludedCustomers?.includes(customerId)) {
      return false;
    }

    return true;
  });
}
